import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { Adequacy, BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/adequacy`;

interface GetLastWorkflowVersionPayload {
  fileId: string;
  adequacies: Adequacy[];
}

async function setFileProductAdequacyCommand({
  fileId,
  adequacies,
}: GetLastWorkflowVersionPayload): Promise<BaseBackResponse> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        values: adequacies,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default setFileProductAdequacyCommand;
